import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  border: 1px solid #ccc;
  padding: 16px;
  margin: 16px 8px;
  border-radius: 4px;
`;

const StoreClosedMessage = () => (
  <StyledDiv>
    <h2>Store Hours</h2>
    <p>Closed</p>
  </StyledDiv>
);

export default StoreClosedMessage;
